module.exports = __webpack_public_path__ + "media/images/dummy/dummy_banner2-b29f73e4416489a65ee21e53089d9e14.jpg";